/* ==========================================================
   UNHATTAR — Heart shower
   - Add to Cart: small burst, ONLY after the cart actually accepts the item
     (works with the theme form, quick add, product-options and cart apps
     because it watches the real /cart/add request, not just the click).
   - Buy Now: bigger burst on click, never delays checkout.
   - Respects prefers-reduced-motion (toast only, no particles).
   ========================================================== */
(function () {
  if (window.__uhHearts) return;
  window.__uhHearts = true;

  var HEARTS = ['❤️', '💖', '💗', '💕', '♥'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastAddButton = null;
  var lastAddAt = 0;
  var lastBurstAt = 0;

  var ADD_SELECTOR = [
    'button[name="add"]', '.product-form__submit', '.quick-add__submit',
    'form[action*="/cart/add"] [type="submit"]', '[data-add-to-cart]', '.add-to-cart', '.btn-addtocart'
  ].join(',');
  var BUY_SELECTOR = [
    '.shopify-payment-button__button', '.shopify-payment-button button', '[data-buy-now]',
    '.gokwik-checkout button', '[class*="gokwik"] button', '[id*="gokwik"]', '.sr-headless-checkout', '[class*="buy-now"]', '[class*="buynow"]'
  ].join(',');

  function rand(a, b) { return a + Math.random() * (b - a); }

  function originOf(el) {
    if (el && el.getBoundingClientRect) {
      var r = el.getBoundingClientRect();
      if (r.width && r.height && r.bottom > 0 && r.top < window.innerHeight) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    }
    return { x: window.innerWidth / 2, y: window.innerHeight * 0.7 };
  }

  function burst(el, opts) {
    opts = opts || {};
    var now = Date.now();
    if (now - lastBurstAt < 350) return; // avoid double bursts from duplicate requests
    lastBurstAt = now;
    if (reduceMotion) return;

    var o = originOf(el);
    var count = opts.count || 18;
    var spread = opts.spread || 140;
    var rise = opts.rise || 240;
    var frag = document.createDocumentFragment();
    var nodes = [];

    for (var i = 0; i < count; i++) {
      var h = document.createElement('span');
      h.className = 'uh-heart';
      h.setAttribute('aria-hidden', 'true');
      h.textContent = HEARTS[Math.floor(Math.random() * HEARTS.length)];
      h.style.left = (o.x + rand(-24, 24)) + 'px';
      h.style.top = (o.y + rand(-8, 8)) + 'px';
      h.style.fontSize = rand(14, opts.big ? 34 : 26) + 'px';
      h.style.setProperty('--uh-x', rand(-spread, spread).toFixed(0) + 'px');
      h.style.setProperty('--uh-y', (-rand(rise * 0.55, rise)).toFixed(0) + 'px');
      h.style.setProperty('--uh-r', rand(-45, 45).toFixed(0) + 'deg');
      h.style.setProperty('--uh-s', rand(0.9, 1.5).toFixed(2));
      h.style.setProperty('--uh-dur', rand(850, opts.big ? 1400 : 1200).toFixed(0) + 'ms');
      h.style.animationDelay = rand(0, 160).toFixed(0) + 'ms';
      frag.appendChild(h);
      nodes.push(h);
    }
    document.body.appendChild(frag);
    setTimeout(function () { nodes.forEach(function (n) { n.remove(); }); }, 1800);
  }

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'uh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    document.body.appendChild(toastEl); // keep it last so it paints above cart drawers
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  function onAdded() {
    var btn = (Date.now() - lastAddAt < 15000) ? lastAddButton : null;
    burst(btn, { count: 18 });
    toast('Made with love! Added to your bag ♥');
  }

  function isAddUrl(url) {
    try { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url && url.url ? url.url : url)); }
    catch (e) { return false; }
  }

  /* Remember which add button was pressed (for the burst origin) */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var add = t.closest(ADD_SELECTOR);
    if (add) { lastAddButton = add; lastAddAt = Date.now(); return; }
    var buy = t.closest(BUY_SELECTOR);
    if (!buy) {
      var b = t.closest('button, a');
      if (b && /buy\s*(it)?\s*now/i.test(b.textContent || '')) buy = b;
    }
    if (buy) burst(buy, { count: 32, spread: 200, rise: 320, big: true });
  }, true);

  /* Watch fetch() — burst only on a successful add */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments);
      if (isAddUrl(input)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) {
            if (data && data.status && data.status >= 400) return; // Shopify error payload
            onAdded();
          }).catch(function () { onAdded(); });
        }).catch(function () {});
      }
      return p;
    };
  }

  /* Watch XMLHttpRequest (used by some cart / product-options apps) */
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__uhAdd = isAddUrl(url);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__uhAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) onAdded();
        });
      }
      return _send.apply(this, arguments);
    };
  }

  /* Plain form posts (no JS cart): show hearts on the cart page after redirect */
  // Bubble phase on window runs after the theme/app handlers, so if any of them
  // took over the submit with JS (preventDefault), we don't set the flag.
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && isAddUrl(f.action) && !e.defaultPrevented) {
      try { sessionStorage.setItem('uh_added', '1'); } catch (err) {}
    }
  }, false);
  window.addEventListener('pageshow', function () {
    try {
      if (sessionStorage.getItem('uh_added') === '1') {
        sessionStorage.removeItem('uh_added');
        setTimeout(onAdded, 250);
      }
    } catch (err) {}
  });

  window.UnhattarHearts = { burst: burst, toast: toast };
})();
